import { useMemo } from 'react';
import { locale } from '../services/locale';
import priceFormatterFactory from '../services/priceFormatterFactory';
import useWidgetContext from './useWidgetContext';
import { usePlatformConfig } from './usePlatformConfig';
export default function usePriceFormatter({ currency, decimals = 2, useCurrencySign = true, separator = '', decimalSeparator = '', currencyFormatConfig, }) {
    const { configuration } = useWidgetContext();
    const { dimensions } = configuration;
    const { language, country } = dimensions;
    const { platformConfig } = usePlatformConfig();
    return useMemo(() => {
        const currencyLocale = locale.getCurrencyLocaleCode(language, country, currency);
        const currencyArgs = useCurrencySign
            ? {
                currency: currency || platformConfig.priceDisplay.primary.currency,
                style: 'currency',
                currencyDisplay: currencyFormatConfig?.currencyDisplay ?? 'symbol',
            }
            : {};
        const priceArgs = {
            ...currencyArgs,
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals,
        };
        return priceFormatterFactory.create(priceArgs, currencyLocale, separator, decimalSeparator, currencyFormatConfig);
    }, [currency, decimals]);
}
//# sourceMappingURL=usePriceFormatter.js.map